export default __webpack_public_path__ + "static/media/hetimiul_1.2c6772aa.png";